import {ParticleConfig, SpawnShapeType} from '@specials/particle-emitter';

export const starsConfig = (): ParticleConfig => ({
  alpha: {
    start: 1,
    end: 0,
  },
  scale: {
    start: 0.05,
    end: 0.3,
  },
  color: {
    start: '#eb7efc',
    end: '#e02dff',
  },
  speed: {
    start: 30 / 60,
    end: 50 / 60,
  },
  direction: {
    minAngle: 0,
    maxAngle: 360,
  },
  lifeTime: {
    min: 1000,
    max: 20000,
  },
  spawnShape: {
    shape: {
      type: SpawnShapeType.Torus,
      x: 0,
      y: 0,
      outerRadius: 200,
    },
  },
});
